import { createContext, ReactNode, useState } from "react";

interface LoadingContextType {
    loading: boolean;
    set_loading: (loading: boolean) => void;
}

export const LoadingContext = createContext<LoadingContextType | undefined>(undefined);


const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [loading, set_loading] = useState<boolean>(true);
    return (
        <LoadingContext.Provider value={{ loading, set_loading }}>{children}</LoadingContext.Provider>
    )
}

export default LoadingProvider